import LegalPage from "./LegalPage";

export default function Privacy() {
  return <LegalPage docKey="privacy" />;
}
